/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

/* This file was auto-generated by ensurePackage() in @jupyterlab/buildutils */
import '@lumino/widgets/style/index.js';
import '@jupyterlab/ui-components/style/index.js';
import '@jupyterlab/apputils/style/index.js';
import '@jupyterlab/codeeditor/style/index.js';
import '@jupyterlab/rendermime/style/index.js';
import '@jupyterlab/application/style/index.js';
import '@jupyterlab/inspector/style/index.js';

import './base.css';
